import { useEffect, useState } from "react";
import Styles from "../../assets/css/components/company/companyView.module.scss";
import { useNavigate, useParams } from "react-router-dom";
import ProductList from "../../pages/ProductList";
import { getCompanyById, getCompanyWarehouseById } from "../../services/Api";
import Loader from '../../utils/Loader';

const CompanyView = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [companyData, setCompanyData] = useState({});
  const [warehouseData, setWarehouseData] = useState([]);
  const [isCompanyLoading, setIsCompanyLoading] = useState(true);
  const [isWarehouseLoading, setIsWarehouseLoading] = useState(true);

  useEffect(() => {
    const fetchCompanyData = async () => {
      setIsCompanyLoading(true);
      try {
        const response = await getCompanyById(id);
        setCompanyData(response.data);
      } catch (error) {
        console.error("Error fetching company data:", error);
      } finally {
        setIsCompanyLoading(false);
      }
    };

    const fetchWarehouseData = async () => {
      setIsWarehouseLoading(true);
      try {
        const response = await getCompanyWarehouseById(id);
        setWarehouseData(response.data);
      } catch (error) {
        console.error("Error fetching warehouse data:", error);
      } finally {
        setIsWarehouseLoading(false);
      }
    };

    fetchCompanyData();
    fetchWarehouseData();
  }, [id]);

  const {
    customer_id = "N/A",
    company_name = "N/A",
    company_uen_number = "N/A",
    email = "N/A",
    contact_number = "N/A",
    address = "N/A",
    country = { name: "N/A" },
    state = { name: "N/A" },
    city = { name: "N/A" },
    main_contact_person_name = "N/A",
    main_contact_person_email = "N/A",
    main_contact_person_phone_number = "N/A",
    remark = "N/A",
  } = companyData;

  return (
    <div className={`${Styles.companyView}`}>
      <div className={`${Styles.companyView_heading}`}>
        <h2>Company View</h2>
        <button className={`${Styles.back_btn}`} onClick={() => navigate("/company")}>Back</button>
      </div>

      <div className={`${Styles.productContainer}`}>
        {/* Image Card - Company Information */}
        <div className={`${Styles.imageCard}`}>
          <h2>Company Information</h2>
          <hr />
          {isCompanyLoading ? (
            <div className={`${Styles.section_loader}`}>
              <Loader size="large" color="primary" />
            </div>
          ) : (
            <>
              <div className={`${Styles.company_details}`}>
                <label>Customer ID (auto-generated)</label>
                <p>{customer_id}</p>
              </div>
              <div className={`${Styles.company_details}`}>
                <label>Company name</label>
                <p>{company_name}</p>
              </div>
              <div className={`${Styles.company_details}`}>
                <label>Company UEN number</label>
                <p>{company_uen_number}</p>
              </div>
              <div className={`${Styles.company_details}`}>
                <label>Phone number</label>
                <p>{contact_number}</p>
              </div>
              <div className={`${Styles.company_details}`}>
                <label>Email</label>
                <p>{email}</p>
              </div>
              <div className={`${Styles.company_details}`}>
                <label>Address</label>
                <p>{address}</p>
              </div>
              <div className={`${Styles.company_details}`}>
                <label>Country</label>
                <p>{country.name}</p>
              </div>
              <div className={`${Styles.company_details}`}>
                <label>State</label>
                <p>{state.name}</p>
              </div>
              <div className={`${Styles.company_details}`}>
                <label>City</label>
                <p>{city.name}</p>
              </div>
            </>
          )}
        </div>

        {/* Product Details Card */}
        <div className={`${Styles.detailsCard}`}>
          <div className={`${Styles.main_contact_person}`}>
            <h2>Main contact person</h2>
            <hr />
            {isCompanyLoading ? (
              <div className={`${Styles.section_loader}`}>
                <Loader size="large" color="primary" />
              </div>
            ) : (
              <>
                <div className={`${Styles.person_details}`}>
                  <label>Contact name person</label>
                  <p>{main_contact_person_name}</p>
                </div>
                <div className={`${Styles.person_details}`}>
                  <label>Email</label>
                  <p>{main_contact_person_email}</p>
                </div>
                <div className={`${Styles.person_details}`}>
                  <label>Phone number</label>
                  <p>{main_contact_person_phone_number}</p>
                </div>
                <div className={`${Styles.person_details}`}>
                  <label>Remark</label>
                  <p>{remark}</p>
                </div>
              </>
            )}
          </div>

          <div className={`${Styles.warehouse_information}`}>
            <h2>Warehouse Information</h2>
            <hr />
            {isWarehouseLoading ? (
              <div className={`${Styles.section_loader}`}>
                <Loader size="large" color="primary" />
              </div>
            ) : warehouseData.length > 0 ? (
              <div className={`${Styles.warehouse_grid}`}>
                {warehouseData.map((warehouse, index) => (
                  <div key={warehouse.id} className={`${Styles.warehouse_card} ${warehouse.is_primary === 1 ? Styles.primary_warehouse : ''}`}>
                    <div className={`${Styles.warehouse_header}`}>
                      <h3>Warehouse {index + 1}</h3>
                      {warehouse.is_primary === 1 && (
                        <span className={`${Styles.primary_badge}`}>Primary</span>
                      )}
                    </div>
                    <div className={`${Styles.warehouse_details}`}>
                      <label>Membership till</label>
                      <p>{warehouse.membership_till || "N/A"}</p>
                    </div>
                    <div className={`${Styles.warehouse_details}`}>
                      <label>Warehouse Name</label>
                      {/* <p>{`SG - ${warehouse.warehouse_id || "N/A"}`}</p> */}
                      <p>{warehouse.warehouse.name || "N/A"}</p>
                    </div>
                    <div className={`${Styles.warehouse_details}`}>
                      <label>Lot #</label>
                      <p>{`${warehouse.min_lot || "N/A"} - ${warehouse.max_lot || "N/A"}`}</p>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className={`${Styles.no_data}`}>
                <p>No warehouse information available.</p>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className={`${Styles.product_details}`}>
        <ProductList companyId={id} companyName={companyData.company_name} filterByCompany={true} navigateFrom="companyView"/>
      </div>
    </div>
  );
};

export default CompanyView;
